export default class CompanyDetails {
    constructor(item = {}) {
        this.company_details = {
            name: "",
            country_id: null,
            vat_number: null,
            vat_country_id: null,
            email: "",
            primary_phone: null,
            store_subscription_plan_id: null
        }
        this.loyalty_details = {
            name: {
                el: "",
                en: "",
                it: ""
            },
            country_id: null,
            points_label: "",
            description: {
                el: "",
                en: "",
                it: ""
            }
        }
    }
}
